<template>
    <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_17177_46009)">
            <path
                d="M12.1458 0.146894C12.1923 0.100331 12.2474 0.0633877 12.3082 0.0381813C12.3689 0.0129748 12.434 0 12.4998 0C12.5656 0 12.6307 0.0129748 12.6914 0.0381813C12.7522 0.0633877 12.8074 0.100331 12.8538 0.146894L15.8538 3.14689C15.9004 3.19334 15.9373 3.24851 15.9625 3.30926C15.9877 3.37001 16.0007 3.43513 16.0007 3.50089C16.0007 3.56666 15.9877 3.63178 15.9625 3.69253C15.9373 3.75327 15.9004 3.80845 15.8538 3.85489L5.85381 13.8549C5.80582 13.9025 5.74867 13.94 5.68581 13.9649L0.685806 15.9649C0.594942 16.0013 0.495402 16.0102 0.399526 15.9905C0.303649 15.9708 0.215653 15.9235 0.146447 15.8543C0.0772403 15.785 0.0298668 15.6971 0.0101994 15.6012C-0.0094681 15.5053 -0.000564594 15.4058 0.0358061 15.3149L2.03581 10.3149C2.06073 10.252 2.09816 10.1949 2.14581 10.1469L12.1458 0.146894ZM11.2068 2.50089L13.4998 4.79389L14.7928 3.50089L12.4998 1.20789L11.2068 2.50089ZM12.7928 5.50089L10.4998 3.20789L3.99981 9.70789V10.0009H4.49981C4.63241 10.0009 4.75959 10.0536 4.85336 10.1473C4.94713 10.2411 4.99981 10.3683 4.99981 10.5009V11.0009H5.49981C5.63241 11.0009 5.75959 11.0536 5.85336 11.1473C5.94713 11.2411 5.99981 11.3683 5.99981 11.5009V12.0009H6.29281L12.7928 5.50089ZM3.03181 10.6759L2.92581 10.7819L1.39781 14.6029L5.21881 13.0749L5.32481 12.9689C5.22943 12.9333 5.1472 12.8693 5.08912 12.7857C5.03104 12.7021 4.99988 12.6027 4.99981 12.5009V12.0009H4.49981C4.3672 12.0009 4.24002 11.9482 4.14625 11.8544C4.05248 11.7607 3.99981 11.6335 3.99981 11.5009V11.0009H3.49981C3.39799 11.0008 3.29862 10.9697 3.21498 10.9116C3.13135 10.8535 3.06744 10.7713 3.03181 10.6759Z"
                :fill="color" />
        </g>
        <defs>
            <clipPath id="clip0_17177_46009">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            default: '#71767D',
        },
        size: {
            type: Number,
            default: 16,
        },
    },
};
</script>